import { getRequest } from './api'

const moduleName = 'area'
export function getAreaList(params = {}) {
  const url = `${moduleName}/index`
  return getRequest(url, params)
}
